import WPStagingCommon from '../../wpstg.js';
import * as dom from '../../modules/wpstg-dom-utils.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupDelete;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupDelete.listen();
  });

  WPStagingBackupDelete = {
    listen() {
      $('#wpstg--tab--backup')
          .off('click', '.wpstg-delete-backup[data-md5]', WPStagingBackupDelete.delete)
          .on('click', '.wpstg-delete-backup[data-md5]', WPStagingBackupDelete.delete);
    },
    delete(e) {
      e.preventDefault();
      WPStagingCommon.resetErrors();

      const name = this.getAttribute('data-name');

      const htmlContent = 'Are you sure you want to delete this backup: ' + name + '?';

      WPStagingCommon.getSwalModal(false, {
        confirmButton: 'wpstg--btn--confirm wpstg-btn-danger wpstg-link-btn',
      }).fire({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Delete',
        icon: 'warning',
        title: 'Delete Backup!',
        html: '<div class="wpstg--modal--delete">' + htmlContent + '</div>',
      }).then((result) => {
        if (!result.value) {
          return;
        }

        dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
        WPStagingCommon.isLoading(true);
        WPStagingCommon.cache.get('#wpstg-existing-backups').hide();
        const md5 = this.getAttribute('data-md5');
        WPStagingCommon.ajax(
            {
              action: 'wpstg--backups--delete',
              md5: md5,
              accessToken: wpstg.accessToken,
              nonce: wpstg.nonce,
            },
            function(response) {
              WPStagingCommon.showAjaxFatalError(response, '', ' Please submit an error report by using the REPORT ISSUE button.');
              WPStagingCommon.isLoading(false);
              WPStagingBackup.fetchListing();
            },
        );
      });
    },
  };
}(jQuery));

export default WPStagingBackupDelete;
